import { render } from "./WalletHistory.vue?vue&type=template&id=e78de848"
import script from "./WalletHistory.vue?vue&type=script&lang=js"
export * from "./WalletHistory.vue?vue&type=script&lang=js"

import "./WalletHistory.vue?vue&type=style&index=0&id=e78de848&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__